import React, {useEffect, useState} from "react";
import {
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Checkbox,
    Box,
    Pagination,
    IconButton
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import {getTicketConfig, sendTicketConfig, saveTicketDesign, getDesigns, deleteDesign} from "../../api/axios";
import { useTranslation } from "react-i18next";

const TicketDesign = ({ ticketData = {} }) => {
    const { t } = useTranslation('global');
    const POS_WIDTH = 300;
    const POS_HEIGHT = 400;

    // Početne vrednosti teksta
    const [initialTexts, setInitialTexts] = useState([
        { id: 1, content: "text1", x: 10, y: 10, fontSize: 14, visible: false },
        { id: 2, content:  "", x: 50, y: 30, fontSize: 14, visible: false, imageUrl: null, imageWidth: 100, imageHeight: 100 },
        { id: 3, content: "category", x: 10, y: 50, fontSize: 14, visible: true },
        { id: 4, content: "description", x: 10, y: 70, fontSize: 14, visible: true },
        { id: 5, content: "kind", x: 10, y: 100, fontSize: 14,visible: true },
        { id: 6, content: "type", x: 10, y: 120, fontSize: 14, visible: true },
        { id: 7, content: "price", x: 10, y: 140, fontSize: 14,visible: true },
        { id: 8, content: "discount", x: 10, y: 160, fontSize: 14, visible: true },
        { id: 9, content: "vat", x: 10, y: 180, fontSize: 14, visible: true },
        { id: 10, content: "endDate", x: 10, y: 200, fontSize: 14,visible: true },
        { id: 11, content: "text2", x: 10, y: 220, fontSize: 16,visible: true },
        { id: 12, content: "text3", x: 10, y: 240, fontSize: 14, visible: false },
    ]);
    const [fetchedDesigns, setFetchDesigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(3); // Show 3 items per page
    const [selectedDesignId, setSelectedDesignId] = useState(null);
    const [config, setConfig] = useState({
        width: POS_WIDTH,
        height: POS_HEIGHT,
        backgroundColor: "#ffffff",
        fontFamily: "Arial",
        textColor: "#000000",
        qrPositionX: 150,
        qrPositionY: 120,
        qrSize: 60,
        texts: initialTexts, // Koristi inicijalne vrednosti
    });

    useEffect(() => {
        const fetchFromMainServer = async () => {
            try {
                console.log("Učitavanje konfiguracije sa glavnog servera...");
                const response = await getDesigns();
                setFetchDesigns(response.data);
                console.log(response.data[0]);
                // TODO: Zameni sa pravim API pozivom kad implementiraš glavni server
                // Na primer: const response = await axios.get('/api/main-server-config');

                // Za sada samo postavi default vrednosti (ili initialTexts)
                // setConfig((prev) => ({
                //     ...prev,
                //     texts: initialTexts
                // }));
                setConfig(response.data[0]);
                setSelectedDesignId(response.data[0].id);
            } catch (error) {
                console.error("Greška pri učitavanju sa glavnog servera:", error);
            }
        };
        fetchFromMainServer();
    }, []);
    const deleteSelectedDesign = async (id) => {
        const deleteResponse = await deleteDesign(id);
        const getResponse = await getDesigns();
        setFetchDesigns(getResponse.data);
        setConfig(getResponse.data[0]);
        setSelectedDesignId(getResponse.data[0].id);
    }
    const fetchFromPrintServer = async () => {
        try {
            const response = await getTicketConfig();

            if (response && response.texts) {
                setInitialTexts(response.texts);
                setConfig({
                    width: response.width || POS_WIDTH,
                    height: response.height || POS_HEIGHT,
                    backgroundColor: response.backgroundColor || "#ffffff",
                    fontFamily: response.fontFamily || "Arial",
                    textColor: response.textColor || "#000000",
                    qrPositionX: response.qrPositionX || 150,
                    qrPositionY: response.qrPositionY || 120,
                    qrSize: response.qrSize || 60,
                    texts: response.texts || [],
                    visible: response.visible || true
                });

            } else {
                console.warn("Print server nije vratio očekivane podatke.");
            }
        } catch (error) {
            console.error("Greška pri učitavanju sa print servera:", error);
        }
    };

    const handleChange = (field, value) => {
        setConfig((prev) => ({ ...prev, [field]: value }));
    };

    const handleTextChange = (id, key, value) => {
        setConfig((prev) => ({
            ...prev,
            texts: prev.texts.map((text) =>
                text.id === id ? { ...text, [key]: value } : text
            ),
        }));
    };
    const handleSave = async () => {
        try{
            const jsonConfig = JSON.stringify(config);
            await saveTicketDesign(jsonConfig);
            const getResponse = await getDesigns();
            setFetchDesigns(getResponse.data);
            setConfig(getResponse.data[0]);
            setSelectedDesignId(getResponse.data[0].id);
        }
        catch (error){
            console.error("Greska pri cuvanju konfiguracije: ", error);
        }
    }
    const handleSendConfig = async () => {
        try {
            await sendTicketConfig(config);
            //alert("Konfiguracija uspešno sačuvana!");
        } catch (error) {
            console.error("Greška pri slanju konfiguracije:", error);
        }
    };

    const handleImageUpload = (id, file) => {
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const imageUrl = e.target.result; // Base64 URL slike

            setConfig((prev) => ({
                ...prev,
                texts: prev.texts.map((text) =>
                    text.id === id
                        ? { ...text, imageUrl: text.content === "" ? imageUrl : text.imageUrl }
                        : text
                ),
            }));
        };
        reader.readAsDataURL(file);
    };

    return (
        <div>
            <Typography variant="h4" style={{ margin: "1% 2%", color: "#2c3e50", marginBottom: "4px" }}>
                {t('user-manuals./ticket-design.title')}
            </Typography>
            <Typography variant="h5" style={{ margin: "0 2%", color: "#2c3e50", marginBottom: "10px" }}>
                {t('ticketDesign.selectExisting')}
            </Typography>
            <div style={{ 
                display: "flex", 
                flexWrap: "wrap",
                justifyContent: "center",
                width: "100%",
                gap: "20px"
            }}>
                {fetchedDesigns
                  .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                  .map((config) => (
                    <div style={{minWidth: '300px'}}>
                    <div style={{display: "flex", flexDirection: "column", margin: "0"}}>
                    <div
                        style={{
                            minWidth: '300px',
                            width: `${POS_WIDTH}px`,
                            height: `${POS_HEIGHT}px`,
                            backgroundColor: selectedDesignId === config.id
                                ? '#e3f2fd'
                                : config.backgroundColor,
                            border: selectedDesignId === config.id
                                ? "2px solid #1976d2"
                                : "2px solid #2c3e50",
                            position: "relative",
                            padding: "10px",
                            borderRadius: "5px",
                            boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
                            scale: "70%",
                            cursor: "pointer",
                            transition: "all 0.3s ease"
                        }}
                        onClick={() => {
                            setConfig(config);
                            setSelectedDesignId(config.id);
                        }}
                    >
                        {/* QR kod */}
                        <div
                            style={{
                                position: "absolute",
                                left: `${config.qrPositionX}px`,
                                top: `${config.qrPositionY}px`,
                                width: `${config.qrSize}px`,
                                height: `${config.qrSize}px`,
                                backgroundColor: "black",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                borderRadius: "5px"
                            }}
                        >
                            QR
                        </div>
    
                        {/* Prikaz samo vidljivih tekstova */}
                        {config.texts
                            .filter((text) => text.visible)
                            .map((text) => (
                                <div
                                    key={text.id}
                                    style={{
                                        position: "absolute",
                                        left: `${text.x}px`,
                                        top: `${text.y}px`,
                                        color: config.textColor,
                                        fontSize: `${text.fontSize}px`,
                                        fontFamily: config.fontFamily
                                    }}
                                >
                                    {text.content === "" ? (
                                        text.imageUrl ? (
                                            <img
                                                src={text.imageUrl}
                                                alt="Slika"
                                                style={{
                                                    width: `${text.imageWidth || 100}px`,
                                                    height: `${text.imageHeight || 50}px`
                                                }}
                                            />
                                        ) : null
                                    ) : (
                                        text.content
                                    )}
                                </div>))}
                                
                        </div>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <IconButton>
                                                        <DeleteIcon onClick={() => deleteSelectedDesign(config.id)}></DeleteIcon>
                                                    </IconButton>
                            </div>
                    </div>
                
                </div>
                
                ))}
            </div>
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={Math.ceil(fetchedDesigns.length / itemsPerPage)}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                color="primary"
              />
            </Box>



            <Button
                variant="outlined"
                color="secondary"
                style={{ backgroundColor: "#2980b9", color: "white", marginTop: 20, marginLeft:20 }}
                onClick={fetchFromPrintServer}
            >
                {t('ticketDesign.loadFromPrintServer')}
            </Button>

            <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: '10px', marginRight: '10px' }}>


            {/* Panel sa podešavanjima */}
            <div style={{flex: '1 1 60%'}}>
                <Typography variant="h5" style={{ color: "#2c3e50", marginBottom: "10px" }}>
                    {t('ticketDesign.posTitle')}
                </Typography>

                <Typography variant="h6" style={{ marginTop: "10px", color: "#34495e" }}>
                    {t('ticketDesign.qrSettingsTitle')}
                </Typography>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px", backgroundColor: "#ecf0f1", borderRadius: "5px" }}>
                    <label style={{ fontWeight: "bold" }}>{t('ticketDesign.qrXLabel')}</label>
                    <input
                        type="range"
                        min="0"
                        max={POS_WIDTH - 50}
                        value={config.qrPositionX}
                        onChange={(e) => handleChange("qrPositionX", Number(e.target.value))}
                    />
                    <label style={{ fontWeight: "bold" }}>{t('ticketDesign.qrYLabel')}</label>
                    <input
                        type="range"
                        min="0"
                        max={POS_HEIGHT - 50}
                        value={config.qrPositionY}
                        onChange={(e) => handleChange("qrPositionY", Number(e.target.value))}
                    />
                    <label style={{ fontWeight: "bold" }}>{t('ticketDesign.qrSizeLabel')}</label>
                    <input
                        type="range"
                        min="20"
                        max="100"
                        value={config.qrSize}
                        onChange={(e) => handleChange("qrSize", Number(e.target.value))}
                    />
                </div>
                </div>


            <div style={{minWidth: '300px', flex: '0 0 30%'}}>
                <div style ={{marginLeft: 'auto', width: 'fit-content'
                    }} >
                <div
                    style={{
                        minWidth: '300px',
                        width: `${POS_WIDTH}px`,
                        height: `${POS_HEIGHT}px`,
                        backgroundColor: config.backgroundColor,
                        border: "2px solid #2c3e50",
                        position: "relative",
                        padding: "10px",
                        borderRadius: "5px",
                        boxShadow: "2px 2px 10px rgba(0,0,0,0.2)"
                    }}
                >
                    {/* QR kod */}
                    <div
                        style={{
                            position: "absolute",
                            left: `${config.qrPositionX}px`,
                            top: `${config.qrPositionY}px`,
                            width: `${config.qrSize}px`,
                            height: `${config.qrSize}px`,
                            backgroundColor: "black",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "10px",
                            borderRadius: "5px"
                        }}
                    >
                        QR
                    </div>

                    {/* Prikaz samo vidljivih tekstova */}
                    {config.texts
                        .filter((text) => text.visible)
                        .map((text) => (
                            <div
                                key={text.id}
                                style={{
                                    position: "absolute",
                                    left: `${text.x}px`,
                                    top: `${text.y}px`,
                                    color: config.textColor,
                                    fontSize: `${text.fontSize}px`,
                                    fontFamily: config.fontFamily
                                }}
                            >
                                {text.content === "" ? (
                                    text.imageUrl ? (
                                        <img
                                            src={text.imageUrl}
                                            alt="Slika"
                                            style={{
                                                width: `${text.imageWidth || 100}px`,
                                                height: `${text.imageHeight || 50}px`
                                            }}
                                        />
                                    ) : null
                                ) : (
                                    text.content
                                )}
                            </div>))}
                    </div>
                </div>
            </div>

        {/*</div>*/}
            <div style={{ marginTop: '20px', padding: '10px' }}>
                {/* Tabela za podešavanje teksta */}
                <Typography variant="h6" style={{ marginTop: "20px", color: "#34495e" }}>
                    {t('ticketDesign.tableTitle')}
                </Typography>
                <TableContainer component={Paper} style={{ maxHeight: "2000px", overflow: "auto", backgroundColor: "#ecf0f1", borderRadius: "5px" }}>
                    <Table size="medium">
                        <TableHead style={{ backgroundColor: "#2c3e50" }}>
                            <TableRow>
                                <TableCell style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                    {t('ticketDesign.tableHeaderText')}
                                </TableCell>
                                <TableCell style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                    {t('ticketDesign.tableHeaderX')}
                                </TableCell>
                                <TableCell style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                    {t('ticketDesign.tableHeaderY')}
                                </TableCell>
                                <TableCell style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                    {t('ticketDesign.tableHeaderFontSize')}
                                </TableCell>
                                <TableCell style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                    {t('ticketDesign.tableHeaderVisibility')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {config.texts.map((text) => (
                                <TableRow key={text.id} style={{ backgroundColor: "#ffffff" }}>
                                    <TableCell>
                                        {text.content === "" ? (
                                            text.imageUrl ? (
                                                <>
                                                    <img
                                                        src={text.imageUrl}
                                                        alt="Učitana slika"
                                                        style={{ width: "100px", height: "50px" }} // Fiksna dimenzija u tabeli
                                                    />
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => handleImageUpload(text.id, e.target.files[0])}
                                                        style={{ marginTop: "5px" }}
                                                    />
                                                </>
                                            ) : (
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageUpload(text.id, e.target.files[0])}
                                                    style={{ marginTop: "5px" }}
                                                />
                                            )
                                        ) : (
                                            <TextField
                                                value={text.content}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;

                                                    // Zaključani: id 3 do 10
                                                    if (text.id >= 3 && text.id <= 10) return;

                                                    // Dozvoljeni: id 1, 11, 12 → ako se briše sve, ostavi razmak
                                                    if ([1, 11, 12].includes(text.id)) {
                                                        handleTextChange(text.id, "content", newValue === "" ? " " : newValue);
                                                        return;
                                                    }

                                                    // Ostali → ne menjaj ništa
                                                    return;
                                                }}
                                                InputProps={{
                                                    readOnly: text.id >= 3 && text.id <= 10
                                                }}
                                                placeholder={t('ticketDesign.textPlaceholder')}
                                            />
                                        )}
                                    </TableCell>

                                    {/* X */}
                                    <TableCell style={{ textAlign: "center" }}>
                                        <input
                                            type="range"
                                            min="0"
                                            max={POS_WIDTH - 50}
                                            value={text.x}
                                            onChange={(e) => handleTextChange(text.id, "x", Number(e.target.value))}
                                        />
                                        <TextField
                                            type="number"
                                            value={text.x}
                                            onChange={(e) => handleTextChange(text.id, "x", Number(e.target.value))}
                                            size="small"
                                            style={{ width: "80px", marginLeft: "10px" }}
                                        />
                                    </TableCell>

                                    {/* Y */}
                                    <TableCell style={{ textAlign: "center" }}>
                                        <input
                                            type="range"
                                            min="0"
                                            max={POS_HEIGHT - 50}
                                            value={text.y}
                                            onChange={(e) => handleTextChange(text.id, "y", Number(e.target.value))}
                                        />
                                        <TextField
                                            type="number"
                                            value={text.y}
                                            onChange={(e) => handleTextChange(text.id, "y", Number(e.target.value))}
                                            size="small"
                                            style={{ width: "80px", marginLeft: "10px" }}
                                        />
                                    </TableCell>

                                    {/* Font size ili image size */}
                                    <TableCell style={{ textAlign: "center" }}>
                                        {text.content === "" && text.imageUrl ? (
                                            <>
                                                <Button
                                                    onClick={() => {
                                                        handleTextChange(text.id, "imageWidth", (text.imageWidth || 100) + 10);
                                                        handleTextChange(text.id, "imageHeight", (text.imageHeight || 50) + 10);
                                                    }}
                                                >
                                                    +
                                                </Button>
                                                <Button
                                                    onClick={() => {
                                                        handleTextChange(text.id, "imageWidth", Math.max((text.imageWidth || 100) - 10, 10));
                                                        handleTextChange(text.id, "imageHeight", Math.max((text.imageHeight || 50) - 10, 10));
                                                    }}
                                                >
                                                    −
                                                </Button>
                                            </>
                                        ) : (
                                            <TextField
                                                type="number"
                                                value={text.fontSize}
                                                onChange={(e) => handleTextChange(text.id, "fontSize", Number(e.target.value))}
                                                size="small"
                                            />
                                        )}
                                    </TableCell>

                                    {/* Visibility */}
                                    <TableCell style={{ textAlign: "center" }}>
                                        <Checkbox
                                            checked={text.visible}
                                            onChange={(e) => handleTextChange(text.id, "visible", e.target.checked)}
                                            color="primary"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
            <div style={{ marginTop: '20px', padding: '10px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSendConfig}
                    style={{ marginTop: 20, backgroundColor: "#2980b9", color: "white" }}
                >
                    {t('ticketDesign.saveToPrintServer')}
                </Button>

                <Button
                    variant="outlined"
                    color="secondary"
                    style={{ backgroundColor: "#2980b9", color: "white", marginTop: 20, marginLeft:20 }}
                    onClick={() => {
                        handleSave();
                    }}
                >
                    {t('ticketDesign.saveToServer')}
                </Button>
            </div>

        </div>

        </div>
    );
};


export default TicketDesign;
